module.exports = __webpack_public_path__ + "static/media/roo_wor_dec_tru.f52f5bfb.png";